"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ScenarioCheck = void 0;
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CSwitch = _interopRequireDefault(require("01_core/components/materials/CSwitch"));
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ScenarioCheck = props => {
  const {
    intl,
    setEntry,
    guidanceEntry
  } = props;
  const isScenarioPolicyIndividual = guidanceEntry.scenarioPolicyCd === _CodeConsts.CODE.BCM_SCENARIO.CODE_03;
  const isScenarioDisplay = guidanceEntry.scenarioDisplayFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1 || guidanceEntry.scenarioDisplayFlg === true;
  if (isScenarioPolicyIndividual && !isScenarioDisplay) {
    const isNecScenario = guidanceEntry.scenarioNecFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1 || guidanceEntry.scenarioNecFlg === true;
    if (isNecScenario) {
      return /*#__PURE__*/_react.default.createElement(_CLabel.default, {
        required: true,
        label: intl.formatMessage({
          id: _labelConsts.LABEL.BCM_BCP_SCENARIO_REGISTER
        }),
        indent: true
      }, /*#__PURE__*/_react.default.createElement(_CSwitch.default, {
        label: intl.formatMessage({
          id: _labelConsts.LABEL.BCM_BCP_NEC_SCENARIO_CHECK
        }),
        checked: guidanceEntry.regNecScenarioCheck === _CodeConsts.CODE.FLG_VALUE.CODE_1 || guidanceEntry.regNecScenarioCheck === true,
        onChange: v => setEntry('regNecScenarioCheck')(v),
        shiftLeft: true
      }));
    } else {
      return /*#__PURE__*/_react.default.createElement(_CLabel.default, {
        required: true,
        label: intl.formatMessage({
          id: _labelConsts.LABEL.BCM_BCP_SCENARIO_REGISTER
        }),
        indent: true
      }, /*#__PURE__*/_react.default.createElement(_CSwitch.default, {
        label: intl.formatMessage({
          id: _labelConsts.LABEL.BCM_BCP_BU_SCENARIO_CHECK
        }),
        checked: guidanceEntry.regBuScenarioCheck === _CodeConsts.CODE.FLG_VALUE.CODE_1 || guidanceEntry.regBuScenarioCheck === true,
        onChange: v => setEntry('regBuScenarioCheck')(v),
        shiftLeft: true,
        disabled: !isScenarioPolicyIndividual
      }));
    }
  }
  return null;
};
exports.ScenarioCheck = ScenarioCheck;
var _default = exports.default = (0, _reactIntl.injectIntl)((0, _CodeUtil.withCodeUtil)(ScenarioCheck));